package com.bikompanion.ui.composables

import androidx.compose.runtime.Composable

// The browser can't launch a native app, and sending someone to a Play listing from the web
// build would be a dead end on most of the machines running it.
@Composable
internal actual fun rememberOperatorAppLauncher(operatorApp: OperatorApp?): (() -> Unit)? = null
